<template>
  <div class="answer">
    <div class="stem">
      <span>{{ idx }}.</span>
      <span class="type">({{ checkType(question.type) }})</span>
      <span>{{ question.question }}</span>
      <span class="score">{{ question.score }}分</span>
      <p class="correct-answer" v-if="question.answerList">
        参考答案：{{ question.answerList[0] }}
      </p>
    </div>
    <div class="options">
      <div
        class="one-row"
        v-for="item in question.userResultList"
        :key="item.resultId"
      >
        <el-image class="avatar" :src="item.avatar" fit="cover"></el-image>
        <div class="row-right">
          <div class="name-row">
            <span class="name">{{ item.nickName }}</span>
            <el-popover
              class="score-pop"
              placement="left"
              title="评分"
              width="160"
              trigger="click"
              :ref="'popover-' + item.resultId"
              :popper-options="{ removeOnDestroy: true }"
            >
              <el-input-number
                v-model="item.score"
                :max="question.score"
                size="small"
              ></el-input-number>
              <div style="text-align: right; margin-top: 10px">
                <el-button
                  size="mini"
                  type="text"
                  @click="handleCancel(item.resultId)"
                  >取消</el-button
                >
                <el-button
                  type="primary"
                  size="mini"
                  @click="changeScore(item.resultId, item.score)"
                  >确定</el-button
                >
              </div>
              <el-button slot="reference" type="text" style="padding: 0"
                >评分</el-button
              >
            </el-popover>
            <span class="score" v-show="item.score">{{ item.score }}分</span>
          </div>
          <div class="content-row">
            <p class="answer">
              {{ item.answerList[0] }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { checkType } from "@/utils/index";
import { quizScore } from "@/api/assistantMode/activity/quiz";
export default {
  props: {
    question: Object,
    idx: Number,
  },
  data() {
    return {
      checkType,
    };
  },
  methods: {
    // 评分
    changeScore(resultId, score) {
      this.$confirm(`评分后不可更改,确定要评分吗？`, {
        type: "warning",
      })
        .then(() => {
          this.$loading.show();
          quizScore({ resultId, score }).then((res) => {
            this.$loading.hide();
            if (res.code == 0) {
              this.$message.success("批改成功");
              this.$emit("update");
            } else {
              this.$message.error(res.msg);
            }
          });
        })
        .catch(() => {});
    },
    handleCancel(id) {
      this.$refs[`popover-${id}`][0].doClose();
    },
  },
};
</script>

<style lang="less" scoped>
.answer {
  height: 100%;
  text-align: left;
  .stem {
    padding: 20px 30px;
    border-bottom: solid 1px #ddd;
    .type {
      margin: 0 5px;
      color: #969696;
    }
    .score {
      margin-left: 10px;
      color: #969696;
      font-weight: bold;
    }
    .correct-answer {
      margin-top: 10px;
      color: #1890ff;
    }
  }
  .options {
    height: calc(100% - 80px);
    overflow: auto;
    &::-webkit-scrollbar {
      width: 4px;
      background-color: #f5f5f5;
    }

    &::-webkit-scrollbar-track {
      box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
      -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
      border-radius: 10px;
      background-color: #f5f5f5;
    }

    &::-webkit-scrollbar-thumb {
      border-radius: 10px;
      box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
      -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
      background-color: #c8c8c8;
    }
    .one-row {
      padding: 20px 30px;
      border-bottom: solid 1px #ddd;
    }
    .avatar {
      margin-right: 20px;
      width: 44px;
      height: 44px;
    }
    .row-right {
      display: inline-block;
      width: calc(100% - 64px);
      vertical-align: top;
      .name-row {
        margin-bottom: 10px;
        width: 100%;
        .score,
        .score-pop {
          float: right;
          &.score {
            margin-top: -2px;
            margin-right: 20px;
            color: #f56c6c;
          }
        }
      }
      .content-row {
        .answer {
          margin-bottom: 5px;
        }
      }
    }
  }
}
</style>